import { wrapWithColorGenerator } from "./color-generator-wrap.js";
import { DefaultVisualModel } from "./default-visual-model.js";
class DefaultVisualModelFactory {
    createNewWritableVisualModelSync(identifier) {
        if (identifier === null) {
            identifier = createIdentifier();
        }
        return wrapWithColorGenerator(new DefaultVisualModel(identifier));
    }
}
const createIdentifier = () => (Math.random() + 1).toString(36).substring(7);
const factory = new DefaultVisualModelFactory();
export function createDefaultVisualModelFactory() {
    return factory;
}
//# sourceMappingURL=visual-model-factory.js.map